angular.module("appModule").factory("usuarioService", factory)

const factory = [
  "loginService",
  "$http",
  "fichaAlumnoService",
  "store",
  function($http, fichaAlumnoService, store) {
    function getUser() {
      return $http({
        method: "GET",
        headers: {
          "Content-Type": "application/json"
        },
        url: fichaAlumnoService.baseUrl + "agenda_usuario/"
      }).then(function(response) {
        return response.data
      })
    }

    function getUserNaive() {
      return $http({
        method: "GET",
        headers: {
          "Content-Type": "application/json"
        },
        url: fichaAlumnoService.baseUrl + "agenda_usuario_simple/",
        params: {
          username: store.get("user").username
        }
      }).then(function(response) {
        return response.data
      })
    }

    return {
      getUser: getUser,
      getUserNaive: getUserNaive
    }
  }
]
